const createBlob = async (base64Data) => {
  // decode base64 string, remove space for IE compatibility
  const r = await fetch(base64Data);
  const blob = await r.blob();
  return URL.createObjectURL(blob);
};

export const base64ToPdfElement = async (url) => `
  <embed
    type="application/pdf"
    src="${await createBlob(url)}"
    width="100%"
    height="100%"
    align="middle"
  />
`;

export default (data, title = 'Prévisualisation') => {
  const document = window.open('about:blank', '_blank').document;
  document
    .write(`
    <html style="background-color: rgb(204, 204, 204);">
      <body
        style="width: 100%;
          height: 100%;
          position: absolute;
          bottom: 0;
          right: 0;
          overflow: auto;"
      >
        ${data}
      </body>
    </html>
  `);
  document.title = title;
  document.close();
};

